import 'babel-polyfill'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import * as filters from './filter'
import axios from 'axios'
import '@/style/normalize.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'wowjs/css/libs/animate.css'
import '@/style/global.css'
import '@/style/mobile.scss'
import wow from 'wowjs'

Vue.prototype.$wow = wow
Vue.use(ElementUI)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.prototype.$axios = axios
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
